import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import * as R from 'ramda'

import Checkbox from 'material-ui/Checkbox';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import PanoramaFishEye from 'material-ui/svg-icons/image/panorama-fish-eye';

import {List, ListItem} from 'material-ui/List'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem'
import Divider from 'material-ui/Divider'

import { dirtyRead, doc } from 'selectors/common'
import { properties, tenants} from 'selectors/entities'
import { projectTasks } from 'selectors/tasks'

import dataActions from 'actions/dataActions'

export class TaskCard extends Component {
	render(){
		let { props } = this
		let doneTask = props.task && props.task.status == "closed"
		let pendingTask = props.task && props.task.status == "pending"
		return(
			(!props.task)?
				<div></div>
				:
				<ListItem
					style={{
						overflow: 'hidden'
					  , paddingLeft: "0"
					  , marginLeft: "0"
					  , margin: "0"
					  , textOverflow: "ellipsis"
					  , fontSize: "16px"
					}}
					innerDivStyle={{
						padding: "0 15px"
					}}
					className="list-hover"
				>
					<Checkbox
						checkedIcon={<CheckCircle />}
						uncheckedIcon={<PanoramaFishEye />}
						style={{
							width: "auto"
						  , position: "absolute"
						  , zIndex: "9999999"
						  , top: "15px"
						}}
						checked={doneTask}
						disabled={pendingTask}
						onCheck={(evt, val) => {
							props.DOC_UPDATE({
								_id: props.task._id
							  , done: val
							})
						}}
					/>
					<Link
						className="task-card"
						to={`/manager/task/${props.task._id}`}
						style={{
							textDecoration: 'none'
						  , position: "relative"
						  , zIndex: "1000"
						  , display: "flex"
						  , justifyContent: "space-between"
						  , width: "100%"
						  , padding: "15px 0"
						  , paddingLeft: "40px"
						}}
						key={props.task._id}
					>
						<p
							style={{
								margin:"0"
							  , paddingTop: "5px"
							  , textDecoration: (doneTask)?"line-through": "none"
							  , color: (pendingTask)? "rgb(180, 180, 180)": "rgba(0, 0, 0, 0.870588)"
							}}
						>
							{(props.task.taskContent)? props.task.taskContent: "No task content"}
						</p>
						{props.task.urgent &&
							<div style={{color: "#fd9a41", paddingTop: "5px"}}>
								URGENT
							</div>
						}
					</Link>
				</ListItem>
		)
	}
}
export default connect(null, dataActions)(TaskCard)



// WEBPACK FOOTER //
// ./src/routes/manager/projectForm/tasks/Card.js